exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SideNote__SideNote___2W_-G{font-weight:500;color:#778195;line-height:1.564rem;font-size:0.9666rem}.SideNote__SideNote--bold___1hrGz{font-weight:700}.SideNote__SideNote--obscure___2TTvw{color:#a8a8a8}.SideNote__SideNote--disabled___1MklY{color:#c2c2c2}\n", ""]);

// Exports
exports.locals = {
	"default-turquoise": "#0d91bd",
	"error-red": "#f9453e",
	"border-grey": "#e9e9e9",
	"white": "#fff",
	"default-blue": "#557eff",
	"glowing-blue": "#0d47ff",
	"text-black": "#555",
	"text-grey": "#778195",
	"disabled-grey-background": "#f9fafb",
	"disabled-light-grey-button": "#c2c2c2",
	"disabled-grey-text": "#a8a8a8",
	"success-green": "#03b571",
	"list-item-grey": "#f3f3f3",
	"outline-color": "#79c2db",
	"greyout": "#fafafa",
	"orange": "#f87748",
	"SideNote": "SideNote__SideNote___2W_-G",
	"SideNote--bold": "SideNote__SideNote--bold___1hrGz",
	"SideNote--obscure": "SideNote__SideNote--obscure___2TTvw",
	"SideNote--disabled": "SideNote__SideNote--disabled___1MklY"
};